import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BeRegra } from 'src/app/models/BeRegra';

@Component({ selector: 'app-dialog-usuario-token-regras', templateUrl: './dialog-usuario-token-regras.component.html' })
export class DialogUsuarioTokenRegrasComponent {
  public selecionadas: number[];
  public constructor(@Inject(MAT_DIALOG_DATA) public data: { regras: BeRegra[], selecionadas: number[] }, private ref: MatDialogRef<DialogUsuarioTokenRegrasComponent>) {
    this.selecionadas = [...data.selecionadas];
  }
  public alterar(id?: number, marcado?: boolean): void {
    if (!id) return;
    this.selecionadas = marcado ? [...new Set([...this.selecionadas, id])] : this.selecionadas.filter(item => item !== id);
  }
  public salvar(): void { this.ref.close(this.selecionadas); }
}
